import { getLoginAndOutGoPath, getTenantList } from '@/api/login';
import { updateCookie } from '@/utils/index';
import { isMobile } from 'react-device-detect';
export const xwOauth = {
    client_id: 'q21ICilXA3493Lm1D',
    response_type: 'code'
};
export const BhyzOauth = {
    client_id: 'bhxw'
};

//获取登录和退出配置，判断登录和退出成功后跳到哪里
export const getLoginAndOutConfig = async () => {
    let res = await getLoginAndOutGoPath();
    if (res && res.code === '00000') {
        return res.data;
    }
    return false;
};

//判断是否使是学员
export const handleIsStudent = async () => {
    const { code, data } = await getTenantList();
    if (code === '00000') {
        for (let i = 0; i < data?.studentTenants.length; i++) {
            if (data.studentTenants[i].domain === window.location.host && !data.studentTenants[i].state) {
                updateCookie(data.studentTenants[i]);
                return true;
            }
        }
        return false;
    }
    return true;
};
export const afterThirdLogin = async () => {
    let { protocol, host } = window.location,
        configUrl = '',
        isStudent = await handleIsStudent();
    console.log(isStudent, '是否是学员');
    let config = await getLoginAndOutConfig();
    if (isStudent) {
        configUrl = config?.login_config?.pc || `${protocol}//${host}/web`;
        if (isMobile) {
            configUrl = config?.login_config?.h5 || `${protocol}//${host}/mobile`;
        }
    } else {
        configUrl = config?.login_config?.admin || `${protocol}//${host}/operate`;
    }

    return configUrl;
};

export const studentAfterThirdLogin = async () => {
    let { protocol, host } = window.location;
    const config = await getLoginAndOutConfig();
    return config?.login_config?.pc || `${protocol}//${host}/web`;
};

export const isEnaeaTenant = (tenantId) => {
    //2005474742481018881-测试环境 网院租户
    //2026570707836936193-生产环境 网院租户
    return tenantId === '2005474742481018881' || tenantId === '2026570707836936193';
};